/*
 * 模块名称: 对账明细列表
 * 创建人: DrugsZ
 * 创建时间: 2018-01-05 14:22:04
 * 修改人:   DrugsZ
 * 最后修改时间: 2018-01-05 14:22:04
 */
<template>
   <div class="wrapper-content animated fadeInRight tabBox" id="billing-list" v-loading="loadingstatus"  element-loading-text="加载中">
      <div class="ibox-content">
          <div class="form-horizontal">
              <div class="form-group">
                  <label for="" class="col-sm-1 control-label">救援公司</label>
                  <div class="col-sm-2">
                        <select class="form-control" v-model="queryParam.customerIds" :disabled="levv==3">
                            <option v-for="item in groupList" :value="item.id" :key="item.id + 'grouplist'">{{item.groupName}}</option>
                        </select>
                  </div>
                  <label for="" class="col-sm-1 control-label">结算状态</label>
                  <div class="col-sm-1 control-label" v-for="(item,index) in udcList" :key="'billing' + index">
                      <checkbox style="line-height:100%;bottom:0" :key = "index" v-model="item.isChecked">{{item.udcname}}</checkbox>
                  </div>
              </div>
              <div class="form-group">
                   <label class="col-sm-1 control-label">救援时间范围(起)</label>
                  <div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
                      <datepicker class="form-control"  v-model="queryParam.startTime"></datepicker>
                      <p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
                  </div>
                   <label class="col-sm-1 control-label">救援时间范围(止)</label>
                  <div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
                      <datepicker class="form-control"  v-model="queryParam.endTime"></datepicker>
                      <p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
                  </div>
                  <label for="" class="col-sm-1 control-label">
                      <a @click="lastSeason">上一季度</a>
                  </label>
                  <label for="" class="col-sm-1 control-label">
                      <a @click="nowSeason">当前季度</a>
                  </label>
                  <label for="" class="col-sm-1 control-label">
                      <a @click="lastMonth">上月</a>
                  </label>
                  <label for="" class="col-sm-1 control-label">
                      <a  @click="nowMonth">本月</a>
                  </label>
              </div>
              <div class="form-group">
                <div class="col-sm-12 t_right">
                    <button class="btn btn-primary" @click="toSearch">查询</button>
                    <button class="btn btn-primary" @click="reset">重置</button>
                </div>
             </div>
             <div class="hr-line-dashed"></div>
             <div class="form-froup t_right">
                <button class="btn btn-primary pd10" @click="exportData">报表导出</button>
            </div>
          </div>
          <div class="table-responsive">
				<div style="overflow: auto;">
					<table class="table mb0px table-striped table-bordered table-hover" style="min-width:1600px;">
						<thead>
			    				<tr role="row">
								<th>救援单号</th>
                                <th>救援状态</th>
								<th>救援请求时间</th>
								<th>抵达耗时(分钟)</th>
								<th>救援结束时间</th>
								<th>救援类型</th>
								<th>被救援车牌号</th>
								<th>救援公司</th>
								<th>救援司机姓名</th>
								<th>救援车牌号</th>
								<th>救援费用(¥)</th>
								<th v-if="levv==2">救援费用结算状态</th>
								<th v-if="levv!=2">平台费用(¥)</th>
								<th v-if="levv!=2">平台费用结算状态</th>
							</tr>
						</thead>
						<transition-group name="list-complete" tag="tbody">
							<tr v-for="(item,index) in dataList" v-bind:key="index" :key="'billingData' + 'index'" class="list-complete-item">
								<td>{{item.idStr}}</td>
								<td>{{item.rescueStatusStr}}</td>
								<td>{{item.requestTimeStr}}</td>
								<td>{{item.sceneElapsedTime}}</td>
								<td>{{item.finishTimeStr}}</td>
                                <td>{{item.rescueTypeStr}}</td>
                                <td>{{item.rescuedPlateNumber}}</td>
                                <td>{{item.customerName}}</td>
                                <td>{{item.driverName}}</td>
                                <td>{{item.plateNumber}}</td>
                                <td>{{item.closingCostStr}}</td>
                                <td v-if="levv==2">{{item.rescueClosingStatusStr}}</td>
                                <td v-if="levv!=2">{{item.platformPriceStr}}</td>
                                <td v-if="levv!=2">{{item.platformClosingStatusStr}}</td>
							</tr>
						</transition-group>
					</table>
				</div>
		  </div>
           <pagination v-if="dataList.length>0" :pageInfo="pageInfo" v-on:getData="getPageNo"></pagination>
           <div class="hr-line-dashed"></div>
           <div class="form-horizontal">
                <div class="form-group">
                  <label class="col-sm-3 control-label t_left">本时间段内累计救援次数：<span style="color:#F23F3C">{{this.totalCount}}</span></label>
                  <label class="col-sm-3 control-label t_left" >统计时间范围:<span style="color:#F23F3C">{{this.startTimeStr}}</span><span v-if="this.startTimeStr!=''||this.finishTimeStr!=''">至</span><span style="color:#F23F3C">{{this.finishTimeStr}}</span></label>
                </div>
                <div class="form-group"  v-if="levv!=2">
                    <label class="col-sm-3 control-label t_left">本时间段内累计平台费用：<span style="color:#F23F3C">{{this.totalPriceStr}}</span><span v-if="this.totalPriceStr!=''"><span v-if="this.totalPriceStr!=''">(¥)</span></span></label>
                </div>
                <div class="form-group" v-if="levv==3||levv==2">
                    <label class="col-sm-3 control-label t_left">本时间段内累计救援费用：<span style="color:#F23F3C">{{this.totalClosingCostStr}}</span><span v-if="this.totalClosingCostStr!=''">(¥)</span></label>
                </div>
                <div class="form-group" v-if="levv==1">
                    <label class="col-sm-3 control-label t_left">计费周期内平台累计救援次数：<span style="color:#F23F3C">{{this.totalRescueTime}}</span></label>
                    <label class="col-sm-3 control-label t_left">统计时间范围：<span style="color:#F23F3C">{{this.startTime}}</span><span v-if="this.startTime!=''||this. endTime!=''">至</span><span style="color:#F23F3C">{{this.endTime}}</span></label>
                    <label class="col-sm-3 control-label t_left">状态：<span style="color:#F23F3C">{{currentCostStatus}}</span></label>
                </div>
                <div class="form-group" v-if="levv==1">
                    <label class="col-sm-3 control-label t_left">计费周期内平台累计平台费用：<span style="color:#F23F3C">{{this.totalPlatformCost}}</span><span v-if="this.totalPlatformCost!=''">(¥)</span></label>
                    <label for="" class="col-sm-1 control-label t_left">费用包含结算状态：</label>
                    <div class="col-sm-1 control-label" v-for="(item,index) in udcTotalList" :key="'udctotal' + index">
                        <checkbox style="line-height:100%;bottom:0" :key = "index" v-model="item.isChecked" @change="loadDataForDidi">{{item.udcname}}</checkbox>
                    </div>
                </div>
           </div>
            <tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
                {{messageStr}}
                <div slot="footer">
                    <button @click="closeModalMsg" class="btn btn-primary">确定</button>
                </div>
            </tab-modal>
      </div>
  </div>
</template>
<script>
	import { getDictionaryFromArray } from 'util/util'
import Checkbox from 'components/common/Checkbox'
import TabModal from 'components/common/TabModal'
import classlist from 'util/classlist'
import {GetTime, deepCopy} from 'util/util'
import { OPERATE_EXCEPTION} from 'static/message'
import Datepicker from 'components/common/datepicker/Datepicker'
import Pagination from 'components/common/Pagination.vue'

export default{
  name: 'PageBillingList',
  data () {
    return {
      groupList: [],
      loadingstatus: false,
      udcList: [],
      udcTotalList: [],
      test: [],
      dataList: [],
      queryParam: {
        customerIds: '',
        endTime: '',
        platformClosingStatus: '',
        startTime: '',
        rescueClosingStatusList: ''
      },
      startTimeStr: '',                   // 统计开始时间
      finishTimeStr: '',                  // 统计结束时间
      totalClosingCostStr: '',               // 本时间段内累计救援费用
      totalCount: '',                     // 本时间段内累计救援次数
      totalPriceStr: '',                  // 本时间段内累计平台费用
                //  timeStr:[],
                //  totalAll:[],
      messageStr: '',
      scrollTop: '0',
      pageInfo: {},
      getTime: {},
      currentCostStatus: '',                       // 当前计费状态
      startTime: '',                               // 开始时间
      endTime: '',                                 // 结束时间
      totalPlatformCost: '',                       // 累计费用 分
      totalRescueTime: ''                        // 累计救援次数
    }
  },
  computed: {
    levv () {
      return this.$store.state.user.levv
    },
    validDates: function () {
	      if (this.queryParam.startTime && this.queryParam.endTime && this.queryParam.startTime > this.queryParam.endTime) {
	        return false
	      } else {
	        return true
	      }
	    }
  },
  components: {
    Checkbox,
    TabModal,
    Datepicker,
    Pagination
  },
  beforeMount () {
    this.getCoustomer()
    this.getUdc()
    this.getTime = new GetTime()
    if (this.levv == 3) this.queryParam.customerIds = this.$store.state.user.groupid
            // this.toSearch()
            // window.getTime = this.getTime;
            // console.log(getTime)
  },
  methods: {
    lastSeason () {
      this.queryParam.startTime = this.getTime.getPriorSeasonFirstDate()
      this.queryParam.endTime = this.getTime.getPriorSeasonEndDate()
    },
    nowSeason () {
      this.queryParam.startTime = this.getTime.getQuarterStartDate()
      this.queryParam.endTime = this.getTime.getQuarterEndDate()
    },
    lastMonth () {
      this.queryParam.startTime = this.getTime.getLastMonthStartDate()
      this.queryParam.endTime = this.getTime.getLastMonthEndDate()
    },
    nowMonth () {
      this.queryParam.startTime = this.getTime.getMonthStartDate()
      this.queryParam.endTime = this.getTime.getMonthEndDate()
    },
    closeModalMsg () {
      this.$refs.modalMsg.close()
      classlist.toggleScroll('open', '#billing-list', this)
    },
    openModalMsg (msg) {
      this.$refs.modalMsg.open()
      this.messageStr = msg
      classlist.toggleScroll('close', '#billing-list', this)
    },
    getCoustomer () {
      this.loadingstatus = true
      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/account/customer/fleet')
                .then(res => {
                  if (res.body.success) {
                    this.groupList = res.body.data
                    if (this.levv != 3) {
                      let obj = {
                        groupName: '全部',
                        id: ''
                      }
                      this.groupList.unshift(obj)
                    }
                  } else {
                    this.openModalMsg(res.body.message)
                  }
                  this.loadingstatus = false
                }, res => {
                  this.openModalMsg(res.body.message)
                  this.loadingstatus = true
                }).catch(res => {
                  this.openModalMsg(OPERATE_EXCEPTION)
                  this.loadingstatus = true
                })
    },
    getColsingStatusStr (item) {
      let n = []
      item.map(item => {
        if (item.isChecked == true) {
          n.push(item.udccode)
        }
      })
      return n.join(',')
    },
    reset () {
      for (let key of this.udcList) {
        key.isChecked = true
      }
      this.queryParam.startTime = ''
      this.queryParam.endTime = ''
      this.queryParam.customerIds = ''
    },
    getUdc () {
      this.loadingstatus = true
      this.$http.get(process.env.API_ROOT + '/system/udcs/license/2', { params: { udcTypes: 'CLOSING_STATUS' } })
                .then(res => {
                  if (res.body.success) {
                    let n = res.body.data.CLOSING_STATUS
                    n.map(item => {
                      item.isChecked = true
                    })
                    this.udcList = n
                    n.forEach(item => {
                      let n = deepCopy(item)
                      this.udcTotalList.push(n)
                    })
                    this.toSearch()
                    this.loadDataForDidi()
                  } else {
                    this.openModalMsg(res.body.message)
                  }
                    // this.loadingstatus = false
                }, res => {
                  this.loadingstatus = false
                  this.openModalMsg(res.body.message)
                }).catch(res => {
                  this.loadingstatus = false
                  this.openModalMsg(OPERATE_EXCEPTION)
                })
    },
    toSearch () {
      this.queryParam.page_index = 1
      this.loadData()
    },
    getPageNo (num) {
      this.queryParam.page_index = num
      this.loadData()
    },
    loadDataForDidi () {
      let params = {}
      params.closingTypes = this.getColsingStatusStr(this.udcTotalList)
                //  this.loadingstatus = true;
      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/cost/current/balance/statistics', {params: params})
                 .then(res => {
                   if (res.body.success) {
                     let data = res.body.data
                     this.currentCostStatus = data.currentCostStatus
                     this.endTime = data.endTime
                     this.startTime = data.startTime
                     this.totalPlatformCost = data.totalPlatformCost
                     if (this.totalPlatformCost > 0) {
                       this.totalPlatformCost = this.totalPlatformCost / 100
                     }
                     this.totalRescueTime = data.totalRescueTime
                   } else {
                     this.openModalMsg(res.body.message)
                   }
                    //   this.loadingstatus = false;
                 }, res => {
                   this.openModalMsg(res.body.message)
                    //   this.loadingstatus = false;
                 }).catch(res => {
                        // this.loadingstatus = false
                   this.openModalMsg(res.body.message)
                 })
    },
    exportData () {
      let url
      url = '/rescue-api/cost/list/account/detail/export'
      this.loadingstatus = true
      this.$http.get(process.env.API_INSURANCE_ROOT + url, {params: this.queryParam})
                .then((res) => {
	                  if (res.body.success) {
	                    let str = res.body.data
				//   var path = "http://192.168.1.53:8888/api";
	                    var path = process.env.EXPORT_PATH
				    var api = process.env.API_ROOT
	                    var fileName = path + api + '/noauth/export?url=' + str + '&path=' + this.$store.state.user.userId
	    			var elemIF = document.createElement('iframe')
			      	elemIF.src = fileName
			        elemIF.style.display = 'none'
			        document.body.appendChild(elemIF)
	                  } else {
	                    this.$emit('onerror', res.body.message)
	                  }
	                  this.loadingstatus = false
	                }, res => {
	                  this.loadingstatus = false
	                  this.$emit('onerror', res.body.message)
	                }).catch(res => {
                  this.loadingstatus = false
                  this.$emit('onerror', '请求异常')
	                })
    },
    loadData () {
                // if(){
                //     this.queryParam.platformClosingStatusList =
                // }else{
                //     this.queryParam.rescueClosingStatusList =
                // }
      this.queryParam.platformClosingStatusList = this.getColsingStatusStr(this.udcList)
      if (this.queryParam.platformClosingStatusList == '') {
        this.openModalMsg('请至少选择一种结算状态')
        return
      }
      if (this.levv == 2) {
        this.queryParam.rescueClosingStatusList = this.queryParam.platformClosingStatusList
        this.queryParam.platformClosingStatusList = null
      }
      this.loadingstatus = true
                // this.queryParam.platformClosingStatus = ''
      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/cost/list/account/detail', {params: this.queryParam})
                .then(res => {
                  this.loadingstatus = false
                  if (res.body.success) {
                    this.dataList = res.body.data.page.list
                    this.dataList.forEach(item => {
                      if (item.closingCost) {
                        item.closingCost = item.closingCost / 100
                      }
                      if (item.plateformPrice) {
                        item.plateformPrice = item.plateformPrice / 100
                      }
                    })
                    const {pageNum, pages, total, isFirstPage, isLastPage} = res.body.data.page
                    this.pageInfo = {
	                      pageNum: pageNum,
	                      pages: pages,
	                      total: total,
	                      isFirstPage: isFirstPage,
	                      isLastPage: isLastPage
	                    }
                    this.startTimeStr = res.body.data.platformClosingCostTotal.startTimeStr
                    this.finishTimeStr = res.body.data.platformClosingCostTotal.finishTimeStr
                    this.totalCount = res.body.data.platformClosingCostTotal.totalCount
                    this.totalPriceStr = res.body.data.platformClosingCostTotal.totalPriceStr
                    this.totalClosingCostStr = res.body.data.platformClosingCostTotal.totalClosingCostStr
                  } else {
                    this.openModalMsg(res.body.message)
                  }
                }, res => {
                  this.loadingstatus = false
                  this.openModalMsg(res.body.message)
                }).catch(res => {
                  this.loadingstatus = false
                  this.openModalMsg(OPERATE_EXCEPTION)
                })
    }
  }
}
</script>



// WEBPACK FOOTER //
// PageBillingList.vue?16a4bdae